export default "__VITE_ASSET__Dfa0HQ0a__"